import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IMedia } from "@/interfaces/media.interface";
import mediaService from "@/services/midia.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetMediaByIdReturn = RequestsBaseReturn<IMedia | null>;

export type UseGetMediaByIdProps = ByIdRequestProps;

type UseSwrGetMediaByIdParams = [string, number | string];

const useGetMediaById = ({ _id }: UseGetMediaByIdProps): UseGetMediaByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IMedia, Error, UseSwrGetMediaByIdParams | null>(
    _id ? [SWR_KEYS.getMediaById, _id] : null,
    ([, mediaId]) => mediaService.getById(mediaId.toString()),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetMediaById;
